import { render, staticRenderFns } from "./CrearFuncionesGlobales.vue?vue&type=template&id=7a24fa26&"
import script from "./CrearFuncionesGlobales.vue?vue&type=script&lang=ts&"
export * from "./CrearFuncionesGlobales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports